__turbopack_context__.v({
  "button": "combo-box-module-scss-module__x9LuxG__button",
  "button-selected": "combo-box-module-scss-module__x9LuxG__button-selected",
  "combo-box-wrapper": "combo-box-module-scss-module__x9LuxG__combo-box-wrapper",
  "dropdown": "combo-box-module-scss-module__x9LuxG__dropdown",
  "error-message": "combo-box-module-scss-module__x9LuxG__error-message",
  "footer": "combo-box-module-scss-module__x9LuxG__footer",
  "icon": "combo-box-module-scss-module__x9LuxG__icon",
  "icon-chevron": "combo-box-module-scss-module__x9LuxG__icon-chevron",
  "icon-search": "combo-box-module-scss-module__x9LuxG__icon-search",
  "label": "combo-box-module-scss-module__x9LuxG__label",
  "label-disabled": "combo-box-module-scss-module__x9LuxG__label-disabled",
  "message": "combo-box-module-scss-module__x9LuxG__message",
  "open": "combo-box-module-scss-module__x9LuxG__open",
  "option-button": "combo-box-module-scss-module__x9LuxG__option-button",
  "option-wrapper": "combo-box-module-scss-module__x9LuxG__option-wrapper",
  "placeholder": "combo-box-module-scss-module__x9LuxG__placeholder",
  "scroll-container": "combo-box-module-scss-module__x9LuxG__scroll-container",
  "search": "combo-box-module-scss-module__x9LuxG__search",
  "search-wrapper": "combo-box-module-scss-module__x9LuxG__search-wrapper",
  "select-hidden": "combo-box-module-scss-module__x9LuxG__select-hidden",
  "wrapper": "combo-box-module-scss-module__x9LuxG__wrapper",
  "wrapper-disabled": "combo-box-module-scss-module__x9LuxG__wrapper-disabled",
});
